export default "__VITE_ASSET__bd6faUfJ__"